import React, {useState} from 'react'
import classNames from 'classnames'
import styles from './DeckDropdown.module.scss'
import { event } from 'react-ga'


const DeckDropdown = ({arenaImportString, mtgoImportString}) => {
  const [showMenu, setShowMenu] = useState(false)
  const [copied, setCopied] = useState("")
  const writeToClipboard = (message) => {
    console.log("Clipboard!")
    navigator.clipboard.writeText(message)
    setShowMenu(false)
    setCopied("Copied to clipboard")
    setTimeout(()=>{setCopied("")}, 1000)
  }

  const handleClick = (event) => {
    setShowMenu(!showMenu)
  }

  return(
    <div class={styles.dropdown}>
      <button class={styles.exportButton}
        onClick={(event)=>{handleClick()}}
        onBlur={(event)=>{setShowMenu(false)}}
      >{copied ? copied : "Export"}</button>
      <div class={classNames(styles.dropdownContent, {[styles.show]: showMenu})}>
          <button 
            key="arena"
            onMouseDown={(event)=>{event.preventDefault()}}
            onClick={(event)=>{writeToClipboard(arenaImportString)}}
            class={styles.dropdownButton}
            title="Export to Arena">
              Copy for Magic Arena
          </button>
          <button 
            key="mtgo"
            onMouseDown={(event)=>{event.preventDefault()}}
            onClick={(event)=>{writeToClipboard(mtgoImportString)}}
            class={styles.dropdownButton}
            title="Export to MTGO">
              Copy for Magic Online
          </button>
        </div>
    </div>
  )
}

export default DeckDropdown